module.exports = __webpack_public_path__ + "static/img/banner_vip.3ff4b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my/banner_vip.png
// module id = URlS
// module chunks = 1